module.exports = __webpack_public_path__ + "img/law-serve-nav-icon04.c34ddc8b.png";